import { Box, Button, Container, Typography } from "@mui/material";
import GroupSvg from "../Assets/Group.svg";

// Define custom colors to match Tailwind theme
const colors = {
    techDark: "#1a202c",
    techBlue: "#2b6cb0",
    techTeal: "#38b2ac",
    techOrange: "#ed8936",
    white: "#ffffff",
    gray200: "#e2e8f0",
    gray500: "#6b7280",
    gray800: "#2d3748",
};

const HeroSection = ({ onExploreProducts }) => {
    return (
        <Box
            component="section"
            sx={{
                position: "relative",
                backgroundColor: "#F8F8F8",
                pt: { xs: 8, sm: 12, md: 16, lg: 20 },
                pb: { xs: 8, sm: 12, md: 16, lg: 20 },
                mb: { xs: 6, sm: 8, md: 10, lg: 12 },
                minHeight: { xs: "200px", sm: "500px", lg: "100vh" },
                width: "100%",
                marginLeft: "calc(-50vw + 50%)",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundImage: `url(${GroupSvg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "0 0",
                }}
            />

            <Container
                sx={{
                    position: "relative",
                    zIndex: 10,
                    px: { xs: 3, md: 0 },
                    maxWidth: '1200px !important',
                    width: "100%",
                    marginLeft: "auto",
                    marginRight: "auto",
                }}
            >
                <Box sx={{
                    display: "flex",
                    flexDirection: { xs: "column", lg: "row" },
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: { xs: 4, lg: 8 },
                }}>
                    <Box
                        sx={{
                            width: { sm: "100%", lg: "60%" },
                            textAlign: "left",
                        }}
                    >
                        <Typography
                            variant="h1"
                            sx={{
                                fontSize: { xs: "1.5rem", sm: "2.5rem", md: "2.75rem", lg: "4.0rem" },
                                fontWeight: 700,
                                color: "#2d3748",
                                lineHeight: 1.1,
                                mb: 4,
                                letterSpacing: "-0.02em",
                                textAlign: "left",
                            }}
                        >
                            Custom Software &{" "}
                            Digital Products, Built
                            Around Your Vision.
                        </Typography>

                        <Box sx={{
                            mt: 6,
                            display: "flex",
                            justifyContent: { xs: "center", sm: "center", lg: "flex-start" }
                        }}>
                            <Button
                                onClick={onExploreProducts}
                                sx={{
                                    bgcolor: "#17273F",
                                    color: colors.white,
                                    px: { xs: 6, sm: 6, lg: 6 },
                                    py: { xs: 1, sm: 2 },
                                    fontSize: { xs: '13px', sm: '17px' },
                                    textTransform: "none",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 12px rgba(66, 133, 244, 0.3)",
                                    "&:hover": {
                                        bgcolor: "#17273F",
                                        transform: "translateY(-2px)",
                                        boxShadow: "0 6px 20px rgba(66, 133, 244, 0.4)",
                                        transition: "all 0.3s ease",
                                    },
                                }}
                            >
                                Explore More
                            </Button>
                        </Box>
                    </Box>

                </Box>
            </Container>
        </Box>
    );
};

export default HeroSection;